module.exports = __webpack_public_path__ + "static/media/bitmap@3x.a60d2ac3.jpg";